<div class="atlas-table t-ar tasks-actions-menu">
  <div
    class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-end mct-items-center mct-justify-start-lt-md mct-items-center-lt-md mct-gap-10 mct-basis-100"
  >
    <action-button
      id="engagementReportsMenu"
      styleClass="atlas-btn-blue"
      [label]="'dashboard.membership-activity.reports.engagement-reports' | translate | uppercase"
      [items]="engagementReportsItems"
    >
    </action-button>

    <action-button
      id="memberReportsMenu"
      styleClass="atlas-btn-blue"
      [label]="'dashboard.membership-activity.reports.member-reports' | translate | uppercase"
      [items]="memberReportsItems"
    >
    </action-button>
  </div>
</div>
